import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { IconBackground } from 'common/components';
import { EColor } from 'common/const';
import { InfoYellow } from 'common/svg';
import { getEmail } from 'common/helpers';
import { IUser } from 'entities/User/User.models';

interface IComponentProps {
  open: boolean;
  user: IUser | null;
  loading: boolean;
  onCancel: () => void;
  onAccept: () => void;
}

export const PersonalLimitDeleteModal: FC<IComponentProps> = ({ open, user, loading, onCancel, onAccept }) => {
  const handleClose = () => {
    if (loading) {
      return;
    }

    onCancel();
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={440}
      centered
      open={open}
      onCancel={handleClose}
      destroyOnClose
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} loading={loading}>
          Отмена
        </Button>,
        <Button key="accept" className="button-sm primary" loading={loading} onClick={onAccept}>
          Снять лимит
        </Button>,
      ]}
    >
      <div className="mb-7">
        <IconBackground content={<InfoYellow className="icon-info-yellow" />} color={EColor.PaleYellow} />
      </div>

      <div className="mb-4 ff-medium fs-m">Снятие лимита с пользователя</div>
      <div className="mb-4 ff-regular fs-s color-dark-grey">{`После снятия лимита пользователь ${getEmail(user?.email)} сможет оформлять заказы на любую сумму без ограничений.`}</div>
      <div className="mb-6 ff-regular fs-s color-dark-grey">Вы уверены, что хотите снять ограничение?</div>
    </Modal>
  );
};
